import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Stars } from "@/components/Stars";
import { api, formatErr } from "@/lib/api";

export function useRatingState(listingId, user) {
  const [state, setState] = useState({ eligible: false, rating: null });
  const reload = () => api.get(`/listings/${listingId}/my-rating`).then((r) => setState(r.data)).catch(() => {});
  useEffect(() => { if (user) reload(); }, [listingId, user]); // eslint-disable-line
  return [state, reload];
}

export function RateDialog({ open, onOpenChange, listingId, sellerName, existing, onDone }) {
  const [stars, setStars] = useState(existing?.stars || 0);
  const [comment, setComment] = useState(existing?.comment || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setStars(existing?.stars || 0); setComment(existing?.comment || ""); }, [existing, open]);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/listings/${listingId}/rate`, { stars, comment });
      toast.success("Thanks for rating!");
      onOpenChange(false); onDone?.();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="rate-dialog" className="border-white/10 bg-[#173742] text-white">
        <DialogHeader>
          <DialogTitle className="font-display">Rate {sellerName}</DialogTitle>
          <DialogDescription className="text-slate-400">How was your pick-up experience?</DialogDescription>
        </DialogHeader>
        <Stars value={stars} onChange={setStars} size="h-8 w-8" testId="rate-star" />
        <textarea data-testid="rate-comment-input" rows={3} maxLength={500} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Friendly, on time, item as described… (optional)" className="field resize-none text-sm" />
        <button data-testid="rate-submit-btn" disabled={!stars || busy} onClick={submit} className="btn-lime w-full py-3 text-sm">{existing ? "Update rating" : "Submit rating"}</button>
      </DialogContent>
    </Dialog>
  );
}
